<template>
  <div class="md">
    <div class="row px-3 pt-2 my-3 py-2">
      <h1>Contact</h1>
      <div class="dropdown">
        <button class="btn btn-dark dropdown-toggle my-2 w-100"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-theme="dark"
                aria-expanded="false">
          {{ selected_subject ? subject_titles[selected_subject] : 'Select a subject'}}
        </button>
        <ul class="dropdown-menu">
          <li v-for="(info, subject) in subject_titles"
              :key="subject">
            <a class="dropdown-item" href="#" @click.prevent="select_subject(subject)">
              {{subject_titles[subject]}}
            </a>
          </li>
        </ul>
        <div v-if="selected_subject=='project'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for reaching out!
          Please send an email to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a> with some information about your project.
          You can also use <a href="https://www.vangemert.dev/project-quotation-ai">my AI tool</a> to generate a draft project quotation.
          I'll typically reply the next working day.
          If we have never worked together before, I'll schedule a call with you to get to know each other.
        </div>
        <div v-if="selected_subject=='workshop'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for reaching out!
          Please send an email to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a> with some information about the desired workshop.
          You can also use <a href="https://www.vangemert.dev/project-quotation-ai">my AI tool</a> to generate a draft project quotation.
          I'll typically reply the next working day.
          If we have never worked together before, I'll schedule a call with you to get to know each other.
        </div>
        <div v-if="selected_subject=='feedback'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for taking the time to provide feedback.
          I welcome all positive and negative feedback.
          Please send your feedback to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a> and I'll typically reply the next working day.
        </div>
        <div v-if="selected_subject=='bug'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for taking the time to report a bug.
          Please send it to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a>.
          I will usually reach out to you to say thanks or ask for further information.
          If you can, please add a screenshot.
        </div>
        <div v-if="selected_subject=='vulnerability'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for reporting a security vulnerability on one of my websites.
          Please send it to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a>.
          I will reach out to you as soon as possible.
          I might ask for further information or ask you to confirm that the vulnerability is fixed.
          Please do not disclose or share the issue publicly until a reasonable amount of time to investigate and address the issue has passed.
        </div>
        <div v-if="selected_subject=='complaint'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          I'm sorry to hear that you want to file a complaint!
          Please send an email to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a> with your complaint and I'll reach out to you as soon as possible.
        </div>
        <div v-if="selected_subject=='other'"
             class="alert alert-success"
             role="alert"
             data-bs-theme="dark">
          Thank you for reaching out!
          Please send an email to <a :href="'mailto:'+obfuscation_parts.join('')" class="email">{{obfuscation_parts.join("")}}</a> and I'll typically reply the next working day.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        selected_subject: "",
        subject_titles: {
          project: 'Request a project',
          workshop: 'Request a workshop',
          feedback: 'Give feedback',
          bug: 'Report a bug on a vangemert.dev website',
          vulnerability: 'Report a security vulnerability on a vangemert.dev website',
          complaint: 'File a complaint',
          other: 'Other',
        },
        obfuscation_parts: ['steven', '@', 'vangemert', '.', 'dev'],
      }
    },
    created() {
      document.title = "Contact"
    },
    methods: {
      select_subject(subject) {
        this.selected_subject = subject
      }
    }
  }
</script>
<style scoped>
  .md {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }

  .dropdown-menu {
    background-color: rgb(30, 30, 30);
  }
  .dropdown-item {
    color: white;
  }

  .email {
    font-family: 'Courier New', monospace;
  }
  .btn-dark.dropdown-toggle {
    background-color: rgb(30, 30, 30) !important;
    border-color: rgb(30, 30, 30) !important;
  }
</style>
